import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import useAuth from '@hooks/useAuth';

export default function PrivateRoute({ element }: { element: ReactNode }) {
  const location = useLocation();

  const { isAuthenticated } = useAuth();

  return isAuthenticated ? (
    element
  ) : (
    <Navigate to={`/?r=${location.pathname}`} />
  );
}
